const APP_CONFIG = {
  jumpingEachClick: 5,
};

export default APP_CONFIG;